import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: -${Spacing.S8};
  margin-bottom: -${Spacing.S16};
`
